<style src="./DistributorMap.scss" lang="scss" scoped></style>
<template>
  <section class="distributor-map">
    <ul class="list">
      <li class="header">
        <icon-star class="iconcheck" title="Distribuidor importado do resultado" />
        <span class="name">Distribuidora</span>
        <span class="cnpj">CNPJ</span>
      </li>
      <li
        class="listitem"
        v-for="(item, itemIdx) in listData"
        :key="itemIdx"
        @click="selectItem(item)">
        <icon-star class="iconcheck" />
        <span class="name">{{ item.name }}</span>
        <span class="cnpj">{{ item.details.cnpj | notFilled('Sem CNPJ') }}</span>
      </li>
    </ul>
  </section>
</template>

<script>
import { IconStar } from '@/components/primitives/icons'
import { CurrencyBR, DecimalNumber } from '@/components/primitives/helpers/filters'

export default {
  name: 'CmedMap',
  components: {
    IconStar
  },
  props: {
    listData: {
      default: null
    }
  },
  filters: {
    CurrencyBR,
    DecimalNumber,
    notFilled (str, strNotFilled = '') {
      if (str && str.trim().length > 1) {
        return str
      } else {
        return strNotFilled
      }
    }
  },
  methods: {
    selectItem (item) {
      this.$emit('selected', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/distributor/components/distributor-map/DistributorMap.vue